import { runInAction } from 'mobx';
import { ocapiClient } from '../../../../api-clients/ocapi/client';
import { getOrder } from '../../selectors/order/get-order';
import { assertIsStandardOrGiftShopOrder } from '../../utils/order-type-utils';
import { registerOrderAction } from '../utils/register-order-action';
/**
 * Sets the customer for the current order. We don't store these locally for security reasons.
 *
 * For [[InProgressSubscriptionOrder]] entities, the customer is automatically set alongside the [[OrderSubscription]].
 */
export const setOrderCustomer = async (customer) => {
    const order = getOrder();
    assertIsStandardOrGiftShopOrder(order, 'Cannot set customer');
    const deregisterAction = registerOrderAction('set-order-customer');
    try {
        await ocapiClient.instance.v1.orders.customer.set(order.id, customer);
    }
    finally {
        deregisterAction();
    }
    runInAction(() => {
        order.hasCustomer = true;
    });
};
